import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = { class: "v-col-6 v-col-md-3" }
const _hoisted_3 = { class: "p-2" }

import Api from '@/services/api'
    import { onBeforeMount, watch } from 'vue'
    import { ref } from 'vue';
    import { ElButton, ElMessageBox, ElRow } from 'element-plus';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Affiliate } from '@/services/types/affiliate';
    import AffiliateView from '@/components/modals/views/AffiliateView.vue';
    import ModalComponent from '@/components/modals/ModalComponent.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AffiliatesView',
  setup(__props) {

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Affiliate>>(defaultPaginated)
    const status = ref<'balance-asc' | 'balance-desc' | 'desc' | 'asc'>('desc')
    const affiliate = ref<Affiliate | null>(null)
    const page = ref<number>(1)

    const getAffiliates = async () => {
        console.log("Okay")
        loading.value = true
        console.log(status.value)
        const res = await Api.get(`admin/affiliates?page=${page.value}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.affiliates
            console.log(res.data)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            console.log(res)
        }
        loading.value = false
    }

    const changePage = (p: number) => {
        page.value = p
        getAffiliates()
    }

    const openAffiliate = (row: any) => {
        // okay
        affiliate.value = row
    }

    onBeforeMount(() => {
        getAffiliates()

        document.title = "Afiliados"
    })

    watch(status, () => {
        page.value = 1
        getAffiliates()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { header: "Afiliados" }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElRow), { class: "py-2" }, {
          default: _withCtx(() => [
            _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "v-col-6 v-col-md-9 me-3" }, "Ordenar por", -1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_radio_group, {
                modelValue: status.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((status).value = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    value: "balance-asc",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                      _createTextVNode("Menor saldo", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "balance-desc",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("Maior saldo", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "desc",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Mais recentes", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    value: "asc",
                    border: ""
                  }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Mais antigos", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }),
        _createVNode(PaginatedTable, {
          loading: loading.value,
          page: data.value.current_page,
          "show-rows": 10,
          pages: data.value.last_page,
          data: data.value.data,
          cols: [
            ],
          onChange: changePage
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "Nome",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Contacto",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.user.phone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Saldo total",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.row.balance.toFixed(2)) + "MT ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Afiliado desde",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createTextVNode(_toDisplayString(new Date(data.row.created_at).toLocaleDateString()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Acções",
              "class-name": "auto",
              "min-width": 150
            }, {
              default: _withCtx((data) => [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_unref(ElButton), {
                    type: "primary",
                    onClick: ($event: any) => (openAffiliate(data.row)),
                    icon: "View",
                    title: "Ver mais"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading", "page", "pages", "data"])
      ]),
      _: 1
    }),
    (affiliate.value)
      ? (_openBlock(), _createBlock(ModalComponent, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = () => {affiliate.value = null}),
          cardclass: "col-12 col-md-6 col-lg-5 col-x-lg-4",
          header: "Informações do pedido"
        }, {
          default: _withCtx(() => [
            _createVNode(AffiliateView, { affiliate: affiliate.value }, null, 8, ["affiliate"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})